export default __webpack_public_path__ + "static/media/team-6@2x.e3ca608b.png";